import { render, staticRenderFns } from "./ToolOnboardingTopCard.vue?vue&type=template&id=012021c4&scoped=true"
import script from "./ToolOnboardingTopCard.vue?vue&type=script&lang=ts"
export * from "./ToolOnboardingTopCard.vue?vue&type=script&lang=ts"
import style0 from "./ToolOnboardingTopCard.vue?vue&type=style&index=0&id=012021c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012021c4",
  null
  
)

export default component.exports